<template>
    <div>

        <ValidationProvider ref="provider" :name="name" :rules="validationString" v-slot="{ errors }">
            <v-switch
                :true-value="trueValue"
                :false-value="falseValue"
                :name="name"
                :id="name"
                :value="value"
                @change="onInput"
                :label="label"
            ></v-switch>
        </ValidationProvider>
    </div>

</template>

<script>
/* eslint-disable */ 
    export default {
        name: 'MdSwitch',
        data() {
            return {
            }
        },
        props: {
            erros:{},
            value: {}, // eslint-disable-line
            name: {
                type: String,
                required: true
            },
            label: {
                type: String,
                default: ''
            },
            trueValue: {
                default: 'S'
            },
            falseValue: {
                default: 'N'
            },
        },
        computed: {
            validationString() {
                let validation = this.validation || [];
                if (this.required) validation.push('required');
                return validation.join('|')
            }
        },
        methods: {
            onInput(event) {
                if (this.disabled) {
                    return;
                }
                this.$emit('input', event);
            }
        },
        mounted() {
            this.$emit('input', this.falseValue);
            console.log(this.erros);

        }

    }

</script>

<style>

</style>
